import React, { FC } from 'react';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';
import { AccountInput, Form } from '~/components';
import { usePath } from '~/hooks';
import { inputWidth, dateWidth } from '~/utils/filters';

const MIN_BANKING_DAY = moment('2025-07-01', 'YYYY-MM-DD');

const Filters: FC = () => {
  const [form] = Form.useForm();
  const { changePath, params } = usePath();
  const { t } = useTranslation('accounts');
  const handleChange = (_changed: any, values: Record<string, any>) => {
    const { bankingDayFrom, bankingDayTo, ...rest } = values;
    const filter = {
      bankingDayFrom: bankingDayFrom?.toISOString(),
      bankingDayTo: bankingDayTo?.toISOString(),
      ...rest,
    };
    changePath({ filter });
  };

  const handleInitialValues = (values?: Record<string, any>): Record<string, any> | undefined => {
    if (!values) return;
    const { bankingDayFrom, bankingDayTo, accountId } = values;
    const filter = {
      bankingDayFrom: bankingDayFrom ? moment(bankingDayFrom) : undefined,
      bankingDayTo: bankingDayTo ? moment(bankingDayTo) : undefined,
      accountId,
    };
    return filter;
  };

  const disabledFromDate = (current?: Moment) => {
    if (!current) return false;
    const to: Moment | undefined = form.getFieldValue('bankingDayTo');
    const tooEarly = current.isBefore(MIN_BANKING_DAY, 'day');
    const afterTo = !!to && current.isAfter(to, 'day');
    return tooEarly || afterTo;
  };

  const disabledToDate = (current?: Moment) => {
    if (!current) return false;
    const from: Moment | undefined = form.getFieldValue('bankingDayFrom');
    const afterToday = current.isAfter(moment(), 'day');
    const beforeFrom = !!from && current.isBefore(from, 'day');
    return afterToday || beforeFrom;
  };

  return (
    <Form
      form={form}
      layout="inline"
      onValuesChange={handleChange}
      initialValues={handleInitialValues(params.filter)}
    >
      <Form.Item name="bankingDayFrom" style={{ marginBottom: 8 }}>
        <DatePicker
          placeholder={t('dayFrom')}
          disabledDate={disabledFromDate}
          allowClear
          style={dateWidth}
        />
      </Form.Item>
      <Form.Item name="bankingDayTo" style={{ marginBottom: 8 }}>
        <DatePicker
          placeholder={t('dayTo')}
          disabledDate={disabledToDate}
          allowClear
          style={dateWidth}
        />
      </Form.Item>
      <Form.Item name="accountId" style={{ marginBottom: 8 }}>
        <AccountInput placeholder={t('account')} allowClear style={inputWidth} />
      </Form.Item>
    </Form>
  );
};

export default Filters;
